module.exports = drupalSettings;